module.exports = __webpack_public_path__ + "db93447865a3344fbe7021b5294bbc60.png";